import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import WithdrawalContainer from 'pages/Withdrawal/Withdrawal.container';
import { WithdrawalMode } from 'services/withdrawal/withdrawal.config';
import { z } from 'zod';

const withdrawalSearchSchema = z.object({
  formIdFromUrl: z.string().optional(),
  amount: z.number().optional(),
  method: z.enum(WithdrawalMode).optional(),
});

export const Route = createFileRoute('/_auth/prelievo/')({
  component: WithdrawalContainer,
  validateSearch: zodValidator(withdrawalSearchSchema),
});
